import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Bulk email module configurations
export const LISTING_COLUMNS = [
  {
    id: 'subject',
    label: 'Subject',
    width: '15%',
    align: 'left',
    dataKey: 'subject',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'senderName',
    label: 'Sender Name',
    width: '12%',
    align: 'left',
    dataKey: 'senderName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'senderEmail',
    label: 'Sender Email',
    width: '12%',
    align: 'left',
    dataKey: 'senderEmail',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.EMAIL_CAMPAIGN_STATUS,
  },
  {
    id: 'recipientCount',
    label: 'Recipient Count',
    width: '10%',
    align: 'center',
    dataKey: 'recipientCount',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sentFailedCount',
    label: 'Sent / Failed',
    width: '10%',
    align: 'center',
    dataKey: 'sentFailedCount',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    label: ACTIONS.VIEW.label,
    action: ACTIONS.VIEW.value,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'subject',
    label: 'Subject',
    dataKey: 'subject',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'senderName',
    label: 'Sender Name',
    dataKey: 'senderName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'senderEmail',
    label: 'Sender Email',
    dataKey: 'senderEmail',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.EMAIL_CAMPAIGN_STATUS,
  },
  {
    id: 'recipientCount',
    label: 'Recipient Count',
    dataKey: 'recipientCount',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sentFailedCount',
    label: 'Sent / Failed',
    dataKey: 'sentFailedCount',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified At',
    dataKey: 'modifiedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'recipients',
    label: 'Recipients',
    dataKey: 'recipients',
    type: CELL_DATA_TYPES.TABLE_LIST,
    tableListColumns: [
      {
        id: 'contactEmail',
        label: 'Email',
        width: '50%',
        align: 'left',
        dataKey: 'contactEmail',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
      },
      {
        id: 'status',
        label: 'Status',
        width: '15%',
        align: 'center',
        dataKey: 'status',
        sortable: true,
        type: CELL_DATA_TYPES.EMAIL_CAMPAIGN_RECIPIENTS_STATUS,
      },
      {
        id: 'sentAt',
        label: 'Sent At',
        width: '20%',
        align: 'right',
        dataKey: 'sentAt',
        sortable: true,
        type: CELL_DATA_TYPES.TIMESTAMP,
      },
    ],
  },
];
